import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnChanges } from '@angular/core';
import { AssistanceBill } from '../../../models/assistance-bill';
import {Country} from '../../../models/country';

@Component({
    selector: 'pay-assistance-bill-form',
    templateUrl: './pay-assistance-bill-form.component.html',
    styleUrls: ['./pay-assistance-bill-form.component.css'],
    standalone: false
})
export class PayAssistanceBillFormComponent implements OnInit, OnChanges {

  pricePaid?: number = null;
  @Input() bill?: AssistanceBill;
  @Input() disabled: EventEmitter<boolean>;
  @Input() country: Country;
  @Output() pay = new EventEmitter<AssistanceBill>();
  @ViewChild('form') form;
  inputFocused = new EventEmitter<boolean>();
  isDisabled = false;

  constructor() { }

  onSubmit() {
    this.isDisabled = true;
    this.bill.price_paid = this.pricePaid;
    this.pay.emit(this.bill);
    this.reset();
  }

  reset() {
    this.pricePaid = null;
    this.form.reset();
  }

  ngOnInit() {
    if (this.disabled) {
      this.disabled.subscribe(disabled => {
        this.isDisabled = disabled;
      });
    }
  }
  ngOnChanges(changes: any) {
    this.inputFocused.emit(true);
  }

}
